module.exports = __webpack_public_path__ + "img/solucion dermica.8439dcab.png";